// extracted by mini-css-extract-plugin
export var bounce = "_kj-1";
export var generatingText = "_kj-6";
export var lightning = "_kj-4";
export var popup = "_kj-5";
export var progressBar = "_kj-7";
export var progressFill = "_kj-8";
export var progressShimmer = "_kj-9";
export var progressText = "_kj-a";
export var shimmer = "_kj-3";
export var uploadIcon = "_kj-0";
export var uploadingText = "_kj-2";